import React from 'react';

export default function IconLiveSupport() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_674_33412)">
        <path
          d="M6.41992 10.3145C6.78742 7.35195 9.31492 5.06445 12.3749 5.06445C14.0324 5.06445 15.5324 5.73945 16.6199 6.81945C17.5349 7.74195 18.1574 8.95695 18.3299 10.3145"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.875 18.3686C15.7244 17.8947 17.2331 16.5603 17.9397 14.8164"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.625 10.3145H7.125V14.8145H5.625C4.8 14.8145 4.125 14.1395 4.125 13.3145V11.8145C4.125 10.9895 4.8 10.3145 5.625 10.3145Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.125 14.8145H17.625V10.3145H19.125C19.95 10.3145 20.625 10.9895 20.625 11.8145V13.3145C20.625 14.1395 19.95 14.8145 19.125 14.8145Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.25 18.1895H13.5C13.7071 18.1895 13.875 18.3573 13.875 18.5645C13.875 18.7716 13.7071 18.9395 13.5 18.9395H11.25C11.0429 18.9395 10.875 18.7716 10.875 18.5645C10.875 18.3573 11.0429 18.1895 11.25 18.1895Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_674_33412">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(3.375 3.06445)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
